// @flow

import stores from 'stores';
import {
  MESSAGE_DISPLAY_TIME,
  MESSAGE_TYPE,
} from '_common/constants/appConfig';

export default (
  message: string,
  duration: number = MESSAGE_DISPLAY_TIME.WARNING
) => {
  return stores.uiStore.showMessage(message, {
    type: MESSAGE_TYPE.WARNING,
    duration,
  });
};
